import { InfoCircleOutlined } from "@ant-design/icons";
import { Popover } from "antd";
import { useTranslation } from "react-i18next";

const TooltipIndexExplains: React.FC<any> = (props) => {
  return (
    <Popover content={PopoverContent} placement="right" showArrow={false}>
      <InfoCircleOutlined />
    </Popover>
  );
};

const PopoverContent: React.FC<any> = (props) => {
  const { t } = useTranslation("radar");

  return (
    <div style={{ width: 700 }}>
      <div className="glossary-text">
        <h2 style={{ color: "#fff" }}>{t("pages.Radar.metrics")}</h2>
        <span style={{ display: "block", marginTop: 16 }}>
          <b>{t("pages.Radar.performance")} - </b>
          {t("pages.Radar.performanceExplaination")}
        </span>

        <span style={{ display: "block", marginTop: 16 }}>
          <b>{t("pages.Radar.development")} - </b>
          {t("pages.Radar.developmentExplaination")}
        </span>

        <span style={{ display: "block", marginTop: 16 }}>
          <b>{t("pages.Radar.music")} - </b>
          {t("pages.Radar.musicExplaination")}
        </span>

        <span style={{ display: "block", marginTop: 16 }}>
          <b>{t("pages.Radar.image")} - </b>
          {t("pages.Radar.imageExplaination")}
        </span>

        <span style={{ display: "block", marginTop: 16 }}>
          <b>{t("pages.Radar.stability")} - </b>
          {t("pages.Radar.stabilityExplaination")}
        </span>
      </div>
    </div>
  );
};

export default TooltipIndexExplains;
